import React, { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme, withStyles } from '@material-ui/core/styles'
import { IconButton, Typography } from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import CustomTable from './Table/table'
import { ACTION, DATE, NAME, REASONS, ROLE, STATUS } from './Table/types'
import getCrfLogs from 'API/functions/getCrfLogs'
import formatLogs from './formatLogs'

export default function LogsModal ({ close, crfNo }) {
  const [logs, setLogs] = useState([])
  useEffect(() => {
    getLogs()
  }, [])

  const getLogs = async () => {
    const data = await getCrfLogs({ crfNo })
    setLogs(data?.response)
  }

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  })

  const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant='h6'>{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label='close'
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    )
  })

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        fullWidth
        maxWidth='lg'
        open
        onClose={close}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='customized-dialog-title' onClose={close}>
          {`${crfNo} logs`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <CustomTable
              headers={[DATE, ACTION, ROLE, REASONS]}
              rowData={[...formatLogs(logs)]}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  )
}
